<template>
	<div v-if="type == 'needs_work'" @click="openCapacitySettings" class="banner">
		<p class="font-medium">Nemáš prácu?</p>
	</div>
	<div v-else @click="openCapacitySettings" class="banner">
		<p class="font-medium">Nemáš nastavené kapacity {{ detail }}!</p>
	</div>
</template>

<script>
export default {

	props: [ 'detail', 'type' ],

	methods: {
		openCapacitySettings() {
			this.$router.push({ name: 'capacity' })
		}
	}
}
</script>

<style scoped>
.banner {
	background-color: rgba(255, 0, 0, 0.5);
	width: 100%;
	text-align: center;
	color: white;
	padding: 0.2px;
	cursor: pointer;
}
</style>